// NOTE: The non `CONSUMED` use of this title are due to `CONSUMED` replacing some deprecated issue types
const CONSUMED_TEXT = 'Script Required';
/**  NOTE: Try to use this shared constant so our terminology is consistent across portals */
export const PRODUCT_ISSUE_TEXT = {
    OUT_OF_STOCK: 'Out of stock',
    PRESCRIPTION_EXPIRED: 'Prescription expired',
    DISPENSE_INTERVAL: 'Dispense Interval',
    DISCONTINUED: 'Discontinued',
    SCRIPT_IN_REVIEW: 'Script in review',
    CONSUMED: CONSUMED_TEXT,
    DISPENSED: CONSUMED_TEXT,
    OUT_OF_REPEATS: CONSUMED_TEXT,
    PENDING_DISPENSE: CONSUMED_TEXT,
    NONE: '',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvZHVjdElzc3Vlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvcHJvZHVjdHMvcHJvZHVjdElzc3Vlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSx5R0FBeUc7QUFDekcsTUFBTSxhQUFhLEdBQUcsaUJBQWlCLENBQUM7QUFFeEMsNkZBQTZGO0FBQzdGLE1BQU0sQ0FBQyxNQUFNLGtCQUFrQixHQUFHO0lBQ2hDLFlBQVksRUFBRSxjQUFjO0lBQzVCLG9CQUFvQixFQUFFLHNCQUFzQjtJQUM1QyxpQkFBaUIsRUFBRSxtQkFBbUI7SUFDdEMsWUFBWSxFQUFFLGNBQWM7SUFDNUIsZ0JBQWdCLEVBQUUsa0JBQWtCO0lBQ3BDLFFBQVEsRUFBRSxhQUFhO0lBQ3ZCLFNBQVMsRUFBRSxhQUFhO0lBQ3hCLGNBQWMsRUFBRSxhQUFhO0lBQzdCLGdCQUFnQixFQUFFLGFBQWE7SUFDL0IsSUFBSSxFQUFFLEVBQUU7Q0FDdUYsQ0FBQyJ9